/**
 * Las direcciones de los archivos guardados.
 *
 * La base guarda la RUTA —«ESC-03.jpg»— y no la dirección completa. El
 * dominio se arma aquí, en un solo sitio: si mañana el depósito cambia de
 * casa, se corrige este archivo y no las catorce filas de la tabla.
 */

const BASE = import.meta.env.VITE_SUPABASE_URL

/**
 * La foto de una herramienta.
 *
 * El depósito es público a propósito y por eso la dirección es directa, sin
 * firmar: son escaleras y taladros, no hay una persona ni una firma en
 * ninguna. Las actas irán en un depósito aparte y privado, y esas sí llevarán
 * dirección firmada y con caducidad.
 */
export function fotoDeHerramienta(ruta: string | null | undefined): string | null {
  if (!ruta) return null
  return `${BASE}/storage/v1/object/public/herramientas/${ruta}`
}
